module.exports = __webpack_public_path__ + "static/img/test7.dde9ac19.png";